export const styles = theme => ({
    root: {
      width: '90%',
      margin: '0 auto'
    },
    chart: {
      margin: "10px",
      padding: theme.spacing.unit * 2,
      textAlign: 'center',
      color: theme.palette.text.secondary,
      height: "100%"
    },
  });


// WEBPACK FOOTER //
// ./src/styles/chart-panel-styles.js